module.exports = __webpack_public_path__ + "static/media/barryGinsberg.ea66a092.jpg";